import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { CompanyAddressesManager } from './CompanyAddressesManager';

export interface CompanyAddressesDialogProps {
  open: boolean;
  companyId: number | null;
  companyName?: string;
  onClose: () => void;
}

/**
 * Wrapper Dialog descartável em torno de `CompanyAddressesManager`. Se um dia
 * quisermos página dedicada `/empresa/:companyId/enderecos`, basta criar
 * `CompanyAddressesPage` envolvendo o mesmo Manager com `<PageHeader>` em vez
 * deste Dialog.
 */
export function CompanyAddressesDialog({
  open,
  companyId,
  companyName,
  onClose,
}: CompanyAddressesDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {companyName
          ? t('features.empresa.enderecos.dialogTitleNamed', { nome: companyName })
          : t('features.empresa.enderecos.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {companyId !== null && <CompanyAddressesManager companyId={companyId} />}
      </DialogContent>
    </Dialog>
  );
}
